import { tsUtils } from '@neo-one/ts-utils';
import { Types } from '../../../constants';
import { BuiltinInstanceMemberCall } from '../../BuiltinInstanceMemberCall';
export class ArrayStoragePush extends BuiltinInstanceMemberCall {
    canCall() {
        return true;
    }
    emitCall(sb, func, node, optionsIn, visited) {
        const options = sb.pushValueOptions(optionsIn);
        if (!visited) {
            sb.visit(tsUtils.expression.getExpression(func), options);
        }
        sb.emitOp(node, 'DUP');
        sb.emitHelper(node, options, sb.helpers.getArrayStorageLength);
        tsUtils.argumented.getArguments(node).forEach((arg) => {
            sb.emitOp(node, 'SWAP');
            sb.emitOp(node, 'TUCK');
            sb.emitOp(node, 'OVER');
            sb.emitHelper(node, options, sb.helpers.wrapNumber);
            sb.visit(arg, options);
            sb.emitHelper(node, optionsIn, sb.helpers.setStructuredStorage({ type: Types.ArrayStorage, keyType: undefined, knownKeyType: Types.Number }));
            sb.emitOp(node, 'INC');
        });
        if (optionsIn.pushValue) {
            sb.emitOp(node, 'TUCK');
        }
        sb.emitHelper(node, options, sb.helpers.putArrayStorageLength);
        if (optionsIn.pushValue) {
            sb.emitHelper(node, options, sb.helpers.wrapNumber);
        }
    }
}

//# sourceMappingURL=push.js.map
